import { PrinterOutlined } from '@ant-design/icons';
import { Button, ConfigProvider, Divider, Form, Row, Space, Spin, Typography } from 'antd';
import React, { useState } from 'react';
import { _T } from '../../../../../base-react/src/Localization';
import { useParams } from 'react-router-dom';
import { hooks, models } from '@vote4dance/judging-sdk';
import { Loading } from '../../../../../base-react/components/Loading';
import { useCompetition } from '../../../../../base-react/hooks/Competition';
var Stream = hooks.streams.Stream;
var HeatSource = models.heats.HeatSource;
var RoundItem = models.rounds.RoundItem;
var HeatsTeamSource = models.teams.HeatsTeamSource;
var ClassRoundSource = models.rounds.ClassRoundSource;
import { PrintStartNumberHeader } from './PrintStartNumber';
import { RoundPathParent } from '../../../../components/RoundPathParent';
const { Title } = Typography;
export const PrintHeat = () => {
    const { competition_id, class_id, round_id } = useParams();
    const [inputCompetition, event, , loadingCompetition] = useCompetition(competition_id);
    const [heats, loadingHeats] = Stream(HeatSource(round_id));
    const [rounds, loadingRounds] = Stream(ClassRoundSource(class_id));
    const [settings, setSettings] = useState({});
    if (loadingCompetition || loadingHeats || loadingRounds) {
        return React.createElement(Loading, null);
    }
    const foundRound = rounds && rounds.find((a) => a.round_id === round_id);
    if (!foundRound) {
        return null;
    }
    return (React.createElement(ConfigProvider, { theme: {
            components: {
                Table: {
                    cellPaddingBlockSM: 0,
                    fontSize: 10
                },
            },
        } },
        React.createElement("style", { type: "text/css", media: "print" }, " @page { size: portrait; margin: 0 !important } "),
        React.createElement(PrintStartNumberSettings, { settings: settings, setSettings: setSettings }),
        React.createElement("div", { style: { margin: 24 } },
            React.createElement(PrintStartNumberHeader, { event: event, competition: inputCompetition, style: { height: 'inherit' } }),
            React.createElement(Space, { orientation: 'vertical', style: { width: '100%' } },
                React.createElement(RoundPathParent, { record: foundRound }, (round, parents) => React.createElement(Title, { level: 5 },
                    React.createElement(Space, { wrap: true, separator: React.createElement(Divider, { orientation: 'vertical' }), size: 'small' },
                        (round.round_beat || round.floor_code) && React.createElement("span", null,
                            round.round_beat,
                            round.floor_code),
                        RoundItem.getClassLabel(round),
                        parents ? parents.map((parent, index) => React.createElement("div", { key: index }, RoundItem.getRoundLabel(parent))) :
                            RoundItem.getRoundLabel(round)))),
                heats && heats.map(heat => React.createElement(PrintHeatItem, { heat: heat, round_id: round_id, key: heat.heat_number, settings: settings }))))));
};
const PrintHeatItem = (props) => {
    const { heat, round_id, settings } = props;
    const [teams, loadingTeams] = Stream(HeatsTeamSource(round_id, heat.heat_number));
    return (React.createElement(React.Fragment, null,
        React.createElement(Divider, { plain: true, style: { margin: 0 } },
            _T('round.heat', { number: heat.heat_number }),
            " - (",
            teams && teams.length,
            ")"),
        loadingTeams ? React.createElement(Spin, null) : (React.createElement(Space, null, teams && teams.map(team => React.createElement("span", { style: { color: 'black', fontWeight: 'bold', textDecoration: team.team_cancelled > 0 ? 'line-through' : undefined }, key: team.heats_team_id }, team.team_start_number))))));
};
const PrintStartNumberSettings = (props) => {
    const { settings, setSettings } = props;
    const onValuesChange = (values) => {
        setSettings({
            ...settings,
            ...values
        });
    };
    const onFinish = () => {
        window.print();
    };
    return (React.createElement(Row, { style: { width: '100%', paddingLeft: 30, backgroundColor: 'lightgrey' } },
        React.createElement("div", { className: "settings" },
            React.createElement("style", null, `@media print {.settings{display: none;}}`),
            React.createElement(Title, null, _T('common.print', { name: _T('round.heat').toLowerCase() })),
            React.createElement(Form, { name: "printsettings", labelCol: { span: 8 }, wrapperCol: { span: 16 }, style: { maxWidth: 600 }, initialValues: settings, onValuesChange: onValuesChange, onFinish: onFinish, autoComplete: "off" },
                React.createElement(Form.Item, { wrapperCol: { offset: 8, span: 16 } },
                    React.createElement(Button, { icon: React.createElement(PrinterOutlined, null), type: "primary", htmlType: "submit" }, _T('common.print')))))));
};
